import { render, staticRenderFns } from "./CourseEventList.vue?vue&type=template&id=4a166558"
import script from "./CourseEventList.vue?vue&type=script&lang=js"
export * from "./CourseEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports